import { NavLink } from 'react-router-dom';
import type { NavSection } from './nav-items';

interface AppNavLinksProps {
  sections: NavSection[];
  onNavigate?: () => void;
}

export function AppNavLinks({ sections, onNavigate }: AppNavLinksProps) {
  return (
    <nav className="flex flex-col gap-4">
      {sections.map((section, index) => (
        <div key={section.title ?? `section-${index}`} className="flex flex-col gap-1">
          {section.title ? (
            <p className="px-3 pb-1 text-xs font-semibold uppercase tracking-wide text-muted">
              {section.title}
            </p>
          ) : null}
          {section.items.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              onClick={onNavigate}
              className={({ isActive }) =>
                [
                  'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors',
                  isActive
                    ? 'bg-accent-soft font-medium text-accent'
                    : 'text-muted hover:bg-default hover:text-foreground',
                ].join(' ')
              }
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </div>
      ))}
    </nav>
  );
}
